import { StateCreator } from 'zustand';

import {
  handleAddTeamsCommunication,
  handleClearTeamsChatsByHomeAccountId,
  handleClearTeamsCommunicationsByTenantId,
  handleDeleteTeamsCommunication,
  handleDeleteTeamsCommunications,
  handleGetTeamsCommunicationById,
  handleSaveTeamsChats,
  handleSetChatCommunications,
  handleSetLoading,
  handleUpdateTeamsCommunication,
} from './handlers';
import { TeamsCommunicationsStore } from './types';

export const createTeamsCommunicationsSlice: StateCreator<
  TeamsCommunicationsStore
> = (set, get) => {
  return {
    chats: [],
    isLoading: false,
    setLoading: (isLoading) => handleSetLoading(set, isLoading),
    saveTeamsChats: (chats) => handleSaveTeamsChats(set, chats),
    addTeamsCommunication: (chatId, communication, isWebSocket) =>
      handleAddTeamsCommunication(set, get, chatId, communication, isWebSocket),
    getTeamsCommunicationById: (chatId, messageId) =>
      handleGetTeamsCommunicationById(get, chatId, messageId),
    updateTeamsCommunication: (chatId, messageId, updatedFields) =>
      handleUpdateTeamsCommunication(
        set,
        get,
        chatId,
        messageId,
        updatedFields,
      ),
    deleteTeamsCommunication: (chatId, messageId) =>
      handleDeleteTeamsCommunication(set, get, chatId, messageId),
    deleteTeamsCommunications: (chatId, messageIds) =>
      handleDeleteTeamsCommunications(set, get, chatId, messageIds),
    setChatCommunications: (chatId, communications) =>
      handleSetChatCommunications(set, get, chatId, communications),
    clearTeamsCommunicationsByTenantId: (tenantId) =>
      handleClearTeamsCommunicationsByTenantId(set, tenantId),
    clearTeamsChatsByHomeAccountId: (homeAccountId) =>
      handleClearTeamsChatsByHomeAccountId(set, homeAccountId),
    resetState: () =>
      set({
        chats: [],
        isLoading: false,
      }),
  };
};
